// custom drawer for SEO content; Since Rhythm drawer uses "react portal feature" (which requires browser API to work ), we make a custom one, which can run on server side rendered page
import classNames from "classnames";
import React, { useEffect, useRef } from "react";

//
const CustomDrawer = ({
  children,
  className,
  isOpen,
  onClose,
  disableCloseOnOutsideClick = false,
}: {
  children: React.ReactNode;
  isOpen: boolean;
  className?: string;
  onClose?: () => void;
  disableCloseOnOutsideClick?: boolean;
}) => {
  const ref = useRef<null | HTMLDivElement>(null);

  useOutsideClick(
    ref,
    isOpen,
    !disableCloseOnOutsideClick ? onClose : undefined
  );

  return (
    <div
      className={classNames({
        "absolute top-0 right-0 bottom-0 left-0 bg-[#0000009e] h-[100vh] ":
          true,
        hidden: !isOpen,
      })}
    >
      <div
        className={classNames({
          [`${className} absolute top-0 right-0 bottom-0 bg-white`]: true,
          "translate-x-full": !isOpen,
          "translate-x-0": !isOpen,
        })}
        ref={ref}
      >
        {children}
      </div>
    </div>
  );
};

export default CustomDrawer;

function useOutsideClick(
  ref: React.MutableRefObject<null | HTMLElement>,
  isOpen: boolean,
  cb?: () => void
) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (isOpen && ref.current && !ref.current.contains(event.target) && cb) {
        cb();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, cb]);
}
